// utils.js

export const getDateLabel = (date) => {
    const now = new Date();
    const d = new Date(date);
  
    const isToday = d.toDateString() === now.toDateString();
    const isTomorrow =
      d.toDateString() === new Date(now.setDate(now.getDate() + 1)).toDateString();
  
    if (isToday) return "Today";
    if (isTomorrow) return "Tomorrow";
  
    return d.toLocaleDateString(undefined, {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };  